export function NotesSection({ notes }: { notes: string; }) {
    return (
        <div className="flex flex-col justify-between bg-orange-100/40 dark:bg-stone-600/30 rounded-md ">
            <p className="indent-2 italic text-base">"{notes ? notes : '(no notes written...)'}"</p>
        </div>
    )
}
